import React from "react";
import styles from "./filterAddMore/FilterAddMore.module.scss";

const FilterAddMore = ({ handleOnClick }) => {

  return (
    <div onClick={handleOnClick} className={[styles.FilterAddMore, 'col-sm-2 d-flex align-items-center'].join(' ')}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 6.24548V11.7403" stroke="#70789E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.75 8.99291H6.25" stroke="#70789E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5143 1.5H5.48571C3.03571 1.5 1.5 3.23406 1.5 5.68887V12.3111C1.5 14.7659 3.02857 16.5 5.48571 16.5H12.5143C14.9714 16.5 16.5 14.7659 16.5 12.3111V5.68887C16.5 3.23406 14.9714 1.5 12.5143 1.5Z" stroke="#70789E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span className={'ml-2'}>Add Filter</span>
    </div>
  )
};

export default FilterAddMore;